import React from "react";
import DashBoard from "./Components/index";
import { fromHourly, toHourly } from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const auth = useAuth();
  const activeMediaGroup = auth.state.activeMediaGroup;
  const fromDate = fromHourly(queryString.parse(props.location.search).date);
  const toDate = toHourly(queryString.parse(props.location.search).date);
  const queryType =queryString.parse(props.location.search).type;

  const onClickLineChart = (date, type = null) => {
    props.history.push(`/media/dashboard/details?activeMediaGroup=${activeMediaGroup}&date=${date}&interval=minutes&type=${type}`);
  };
  const onClickListButton = (date, type = null) => {
    props.history.push(`/media/dashboard/details?activeMediaGroup=${activeMediaGroup}&date=${date}&interval=hourly&type=${type}`);
  };
  const handleDateChange = (date, type = null) => {
    props.history.push(`/media/dashboard/hourly?activeMediaGroup=${activeMediaGroup}&date=${date}&type=${type}`);
  };

  return (
    <DashBoard
      fromDate={fromDate}
      toDate={toDate}
      unit="min5"
      target="hourly"
      type={queryType}
      onClickLineChart={onClickLineChart}
      onClickListButton={onClickListButton}
      handleDateChange={handleDateChange}
    />
  );
}

export default withRouter(Page);
